module.exports = __webpack_public_path__ + "img/jizuo.prt.e6b636cd.jpg";